import React, { FunctionComponent, useEffect } from 'react';
import { Switch } from 'react-router-dom';
import MakeSubRoutes from './makeSubRoutes';
import { consignerRoutes } from './routes';
import Menu from '../components/Menu';
import Header from '../components/UI/Molecules/Header';
import { webViewtheme } from '../utils/theme';
import { ThemeProvider } from 'styled-components';
import Toaster from '../components/Toaster';
import Loader from '../components/Loader';
import { buildDate } from '../utils/buildInfo';

const Portal: FunctionComponent<any> = () => {
  useEffect(() => {
    console.log('Build Code: ' + buildDate);
  }, []);

  return (
    <ThemeProvider theme={webViewtheme}>
      <Menu type="CONSIGNER" />
      <Header />
      <Switch>
        {consignerRoutes.map((route: object, index: number) => (
          <MakeSubRoutes key={index} {...route} />
        ))}
      </Switch>
      <Toaster />
      <Loader />
    </ThemeProvider>
  );
};

export default Portal;
